// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { menuActionCreators } from '../../actions';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import { LocalStorageMissionsKeys } from '../../modules/missions/constants/storage';
import { storage } from '../../utils';

import MenuDesktop from './MenuDesktop';
import makeMenuDesktopPropsSelector from './MenuDesktop.selector';

const MenuDesktopContainer = () => {
  const {
    params: { matchId },
  } = useRouter();

  const seenMissions = storage.localStorage.load(LocalStorageMissionsKeys.SEEN_MISSIONS);

  const selectorProps = useMemo(
    () => ({
      seenMissions: seenMissions ?? [],
      matchId,
    }),
    [seenMissions, matchId],
  );

  const selector = useMemo(() => makeMenuDesktopPropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const menuActions = useBindActionsCreator(menuActionCreators);
  const actionsProps = useMemo(() => ({ actions: menuActions }), [menuActions]);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return <MenuDesktop {...enhancedProps} />;
};

export default MenuDesktopContainer;
